import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Online shop',
        [PolygraphyProductUrlType.Storefront]: 'Storefront',
        [PolygraphyProductUrlType.Custom]: 'Benutzerdefiniert',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Änderungen speichern, um die Vorschau zu sehen',
  },
  buttons: {
    save_and_preview: 'Speichern und Vorschau',
  },
  toasts: {
    failed_to_load_data: 'Artikel fehlgeschlagen!',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden!',
    changes_got_saved: 'Änderungen wurden gespeichert!',
  },
};
